// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"f4a3e753","230":"dd360af9","581":"8454d9b1","747":"d0ec33f4","899":"2e0d3ab5"}[chunkId] + ".chunk.js";
};